import QaRolesCustomSelectField from './QaRolesCustomSelectField.component';

export default QaRolesCustomSelectField;
